import { DeleteTwoTone } from "@ant-design/icons";
import { message, Popconfirm } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteUser } from "../../../redux/User/actions";

export const DeleteUser=({ item }) =>{
  const auth_id = useSelector((state) => state.auth.user._id);
  
  const dispatch = useDispatch();
  const deleteUsert_fun = () => {
    if (item._id === auth_id) {
      message.warning("Impossible de supprimer votre Compte ");
    }else{
      dispatch(deleteUser(item._id));
      message.success("Deleted");
    }
   
  };
  const confirm = (e) => {
    deleteUsert_fun();
    
  };

  const cancel = (e) => {
    
  }
  return (
    <Popconfirm
      onConfirm={confirm}
      onCancel={cancel}
      title="Êtes-vous sûr de vouloir supprimer ?"
      okText="Oui"
      cancelText="Non"
    >
      <DeleteTwoTone
        style={{ width: '100%' }}
        twoToneColor="red"
        key="Delete"
      />
    </Popconfirm>
  );
}

export default DeleteUser;
